import { router } from 'expo-router';
import { ScreenContainer, View } from 'smoothie';

import Kyc, { KycFlowSourceEnum } from '../../../../banking/components/kyc/Kyc';
import UnderReview from '../../../../banking/components/kyc/steps/UnderReview';
import { useViewEvents } from '../../../../events/hooks/useViewEvents';

interface CashAccountsSheetProps {
    isOpen: boolean;
    onClose: () => void;
    onKycAccepted: () => void;
}

export const KycFlowSheet: React.FC<CashAccountsSheetProps> = ({
    isOpen,
    onClose,
    onKycAccepted,
}) => {
    return (
        <Kyc
            kycFlowSource={KycFlowSourceEnum.GO_FLOW_ACCOUNT_OPENING}
            isInsideModal={true}
            isOpen={isOpen}
            onClose={(isKycAccepted: boolean) => {
                onClose();
                if (isKycAccepted) {
                    onKycAccepted();
                }
            }}
        />
    );
};

export const AccountStepBlocked = () => {
    const { trackViewOnce } = useViewEvents();
    trackViewOnce('Roadmap/Go/KYCUnderReview');

    return (
        <ScreenContainer
            hasCloseButton={true}
            onClose={() => {
                router.navigate('/home');
            }}
        >
            <View flex={1} width="100%" paddingTop={60}>
                <UnderReview />
            </View>
        </ScreenContainer>
    );
};
